/**
 * @desc 创建订阅
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(
  shopCode: string,
  body: defs.walmart.CreateSubscriptionsRequest,
  options?: any,
) {
  return updateResponse(
    http(URL + `/walmart/WalmartNotifications/createSubscriptions/${shopCode}`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
